import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCGrFkdJlMf9zuXeZv_YIk_NYJ3Jbq6_c4',
  authDomain: 'am-padel-club-project.firebaseapp.com',
  projectId: 'am-padel-club-project',
  storageBucket: 'am-padel-club-project.firebasestorage.app',
  messagingSenderId: '412250494691',
  appId: '1:412250494691:web:d5a269fa60c996bb1797d6',
  measurementId: 'G-W652KY577C',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
